/* Copyright (c) Trimble Inc. All rights reserved. */
import React from "react";
import { Box } from "@material-ui/core";
import { useGlobalProductDetailsController } from "../controller/GuestProductDetailsController";
import { GuestProductSummaryDetailsViewer } from "./GuestProductSummaryDetails";

export const GuestProductSummary: React.FC = () => {
  const { response } = useGlobalProductDetailsController();

  return (
    <Box m={2}>
      <GuestProductSummaryDetailsViewer response={response} />
    </Box>
  );
};

export default GuestProductSummary;
